// TEMPORARY debug scaffolding — captures all console output + global errors into
// window.__debugLogs so they can be read on devices with no dev console (e.g. iOS Discord).
// Remove once the Twitch/iOS investigation is done.

const MAX_LOGS = 500;

function pushLog(level: string, args: unknown[]) {
    const logs: string[] = ((window as any).__debugLogs = (window as any).__debugLogs || []);
    let msg: string;
    try {
        msg = args
            .map((a) => {
                if (typeof a === 'string') return a;
                if (a instanceof Error) return `${a.name}: ${a.message}`;
                try {
                    return JSON.stringify(a);
                } catch {
                    return String(a);
                }
            })
            .join(' ');
    } catch {
        msg = args.map(String).join(' ');
    }
    logs.push(`${new Date().toISOString().slice(11, 23)} [${level}] ${msg}`);
    if (logs.length > MAX_LOGS) logs.splice(0, logs.length - MAX_LOGS);
}

export function installDebugCapture() {
    if ((window as any).__debugCaptureInstalled) return;
    (window as any).__debugCaptureInstalled = true;

    (['log', 'info', 'warn', 'error', 'debug'] as const).forEach((level) => {
        const original = console[level].bind(console);
        console[level] = (...args: unknown[]) => {
            pushLog(level, args);
            original(...args);
        };
    });

    window.addEventListener('error', (e) => {
        pushLog('window.error', [
            e.message,
            e.filename ? `${e.filename}:${e.lineno}:${e.colno}` : '',
            e.error instanceof Error ? e.error.stack : '',
        ]);
    });

    window.addEventListener('unhandledrejection', (e) => {
        const reason = (e as PromiseRejectionEvent).reason;
        pushLog('unhandledrejection', [reason instanceof Error ? `${reason.name}: ${reason.message}` : reason]);
    });

    document.addEventListener('securitypolicyviolation', (e) => {
        pushLog('csp', [
            `blocked=${e.blockedURI}`,
            `directive=${e.violatedDirective}`,
            `disposition=${e.disposition}`,
            `source=${e.sourceFile}:${e.lineNumber}`,
        ]);
    });

    pushLog('info', ['debugCapture installed']);
}
